"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoftwareLicensesFilterBody = SoftwareLicensesFilterBody;
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const FormContext_1 = require("../../View/Modals/FormContext");
function SoftwareLicensesFilterBody() {
    const { register } = (0, FormContext_1.useFormContext)();
    return react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "licenseSearchText" },
        react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Szukana fraza"),
        react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "Producent, produkt, przypisanie lub uwagi", maxLength: 255, ...register("searchText") }));
}
